import React from "react";
import { defineMessages, injectIntl } from 'react-intl';
import Helpers from '../lib/helpers'
import { profile } from "../stores/storages/ProfileStorage";
import { Tinode } from "../tinode/tinode";

const messages = defineMessages({
  deeplink_supports_only_mobile: {
    id: "deeplink_supports_only_mobile",
    defaultMessage: "This content is only supported on your mobile device",
    description: "Warning for deeplink button"
  }
});

class DeeplinkMessage extends React.Component {
  constructor(props) {
    super(props);

    this.handleOnClickDeeplink = this.handleOnClickDeeplink.bind(this);
    this.getDeplinkMocha = this.getDeplinkMocha.bind(this);
    this.addUuidToUrl = this.addUuidToUrl.bind(this);
  }

  handleOnClickDeeplink(deeplink) {
    const { formatMessage } = this.props.intl;
    const { uuid } = profile;
    const { define, ref } = this.getDeplinkMocha(deeplink);
    if (!!uuid) {
      switch (define) {
        case Tinode.DEEPLINK_SUPPORT.SURVEY:
          const url = this.addUuidToUrl(ref);
          window.open(url, '_blank', 'toolbar=yes,scrollbars=yes,resizable=yes,top=100,left=100,width=1024,height=867')
          break;
        default:
          Helpers.showWarningToasts(formatMessage(messages.deeplink_supports_only_mobile))
          break;
      }
    } else {
      Helpers.showWarningToasts(formatMessage(messages.deeplink_supports_only_mobile))
    }
  }

  getDeplinkMocha(deeplink) {
    let arr = deeplink.split("?ref=");
    return {
      'define': arr[0],
      'ref': decodeURIComponent(arr[1])
    }
  }

  addUuidToUrl(url) {
    const { uuid } = profile;
    let separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + `uuid=${uuid}`;
  }



  renderButton() {
    console.log(this.props)
    const { deeplink } = this.props
    if (deeplink) {
      return (
        <React.Fragment>
          {
            deeplink.left && <button
              className="deeplink-button"
              onClick={() => this.handleOnClickDeeplink(deeplink.left.link)}
            >
              {deeplink.left.button}
            </button>
          }
          {
            deeplink.right && <button
              className="deeplink-button"
              onClick={() => this.handleOnClickDeeplink(deeplink.right.link)}
            >
              {deeplink.right.button}
            </button>
          }
        </React.Fragment>

      )
    }
    return ''
  }

  render() {
    return (
      <div className="deeplink-message-container">
        <div className="deeplink-body">
          {this.props.body}
        </div>
        <div className='deeplink-button-group'>
          {this.renderButton()}
        </div>
      </div>
    )
  }
}

export default injectIntl(DeeplinkMessage);